import React from "react";
import { Row, Col } from "react-flexbox-grid";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  paper: {
    padding: theme.spacing.unit * 3,
    marginTop: theme.spacing.unit * 2
  }
});

const DetailsSection = props => {
  const { title, children, classes } = props;
  return (
    <Row>
      <Col xs={12}>
        <Paper className={classes.paper}>
          {title && title !== '' &&
            <React.Fragment>
              <Typography variant="h3" gutterBottom>
                {title}
              </Typography>
              <Divider light />
            </React.Fragment>
          }
          {children}
        </Paper>
      </Col>
    </Row>
  );
};

export default withStyles(styles)(DetailsSection);



// WEBPACK FOOTER //
// ./src/components/admin/indicators/details-section.js